











































































import GuidanceMixin from '@/mixins/guidance/GuidanceMixin';
import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';

export default {
  name: 'CopyStakeGuidanceView',
  mixins: [GuidanceMixin, FeatureFlagRedirectMixin]
};
